import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-questionbank',
  templateUrl: './questionbank.component.html',
  styleUrls: ['./questionbank.component.scss'],
  providers:[MasterService]
})
export class QuestionbankComponent implements OnInit {

  arrqseg:any=[];
  arrqcat:any=[];
  arrqbank:any=[];
  arranstype:any=[];
  arrevlmanswer:any=[];
  objqbank:any={};
  objans:any={};
  oprtype='';
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  fileToUpload: File = null;
  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
    
    this.sel_evlmqbank('select',1);
    this.sel_evlmanstype();
    this.sel_evlmqcategory();
    this.sel_evlmqsegment();
  }



  sel_evlmanstype() {
    this.mservice.sel_evlmanstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arranstype = resultArray;
            //this.objqbank.anstypeid=resultArray[0].anstypeid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  sel_evlmqcategory() {
    this.mservice.sel_evlmqcategory()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqcat = resultArray;
            //this.objqbank.qucatid=resultArray[0].qucatid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }

  sel_evlmqsegment() {
    this.mservice.sel_evlmqsegment()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqseg = resultArray;
           // this.objqbank.qusegid=resultArray[0].qusegid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }

  sel_evlmqbank(oprtype,tag) {
    this.mservice.sel_evlmqbank(oprtype,tag)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqbank = resultArray;
            // this.objqbank.qusegid=resultArray[0].qusegid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  sel_evlmanswer(quid) {
    this.mservice.sel_evlmanswer(quid)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevlmanswer = resultArray;
            // this.objqbank.qusegid=resultArray[0].qusegid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  openans(content,obj) {
    debugger
    this.sel_evlmanswer(obj.quid);
      this.objans={};
      this.objans.rid='0';
      this.objans.quid=obj.quid;
      this.objans.ansdis='';
      this.objans.score='0';
      this.objans.inid=localStorage.getItem('masclid');
      this.objans.usid=localStorage.getItem('usid');
      this.objans.oprtype='insert';

     
      
     
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
    
  openasses(content,objdata,cmd) {
    debugger
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objqbank={};
     
      
      
      this.objqbank.quid='0';
      this.objqbank.qudis='';
      this.objqbank.imgpath='';
      this.objqbank.inid=localStorage.getItem('masclid');
      this.objqbank.qusegid=this.arrqseg[0].qusegid;
      this.objqbank.anstypeid=this.arranstype[0].anstypeid;
      this.objqbank.qucatid=this.arrqcat[0].qucatid;
      // this.objsubcat.subcacd='';
      //this.objsubcat.subcanm='';
      this.objqbank.oprtype='insert';
     
    }
  
    else if(cmd=='update')
    {
      
      this.objqbank=objdata;
      this.objqbank.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  upload(files: FileList) {
    debugger;
    console.log(files);

    if (files[0].type=="image/jpeg"|| files[0].type=="image/jpg" || files[0].type=="image/png")
    {

    this.fileToUpload = files.item(0);
    }
    else{

      alert('Please upload valid image.');
    }
  
   // this.fData.append("bkid", this.memid.toString());
    //this.fData.append("docpurpose", "Studentphoto");
  
    // this.SService.uploadFile(fData).subscribe(
    //     response => this.handleResponse(response),
    //     error => this.handleError(error)
    // )
  }

  saveastype()
{
 console.log('saveobj',this.objqbank);
 if( this.fileToUpload!=null && this.fileToUpload.size>200000)
{

  alert ('Image size should be less than 200KB');
  // this.showload='no';
}

else
{
  this.mservice.save_evlmqbank(this.objqbank,this.fileToUpload)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
          //  this.masasstype();
          this.sel_evlmqbank('select',1);
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}
}


editevlans(obj)
{
  this.objans={};
  this.objans=obj;

  this.objans.inid=localStorage.getItem('masclid');
  this.objans.usid=localStorage.getItem('usid');
  this.objans.oprtype='update';
  
}
saveevlmans()
{
  this.mservice.save_evlmanswer(this.objans)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            // let localmodref=this.modalRef;
            // localmodref.close();
          //  this.masasstype();

          this.objans.rid='0';
          // this.objans.quid=obj.quid;
          this.objans.ansdis='';
          this.objans.score='0';
          this.objans.inid=localStorage.getItem('masclid');
          this.objans.usid=localStorage.getItem('usid');
          this.objans.oprtype='insert';
          this.sel_evlmanswer(this.objans.quid);
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}

}
